<template>
  <LcBadge
    v-if="status === SubscriptionStatus.Cancelled"
    class="bg-accent-danger-danger"
    icon="subscription-deactivated"
  >
    {{ $t(`myorders.status.subscription.${status}`) }}
  </LcBadge>
</template>

<script lang="ts" setup>
import { SubscriptionStatus } from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersStatusBadgeSubscriptionProps = {
  status?: Maybe<SubscriptionStatus>
}

defineProps<MyOrdersStatusBadgeSubscriptionProps>()
</script>
